// extracted by mini-css-extract-plugin
export default {"element":"HorseStats_element__TOd8o","icon":"HorseStats_icon__x0eEO"};